import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import ReactPaginate from "react-paginate";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  // paginação vagas efetivas
  const itemsPerPage = 5;
  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const currentEffectiveJobs = filteredJobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs,
  );
  const pageCountEffectiveJobs = Math.ceil(filteredJobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs.length;
    setItemOffsetEffectiveJobs(newOffset);
    setCurrentPage(event.selected);

    document.getElementById("oportunidades").scrollIntoView();
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const closeMenu = () => {
    setShowMenu(false);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  const onChangeFilterJobsCity = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "kraftheinz",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setJobs(jobsData.jobPositionList);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  return (
    <div onMouseDown={closeMenu}>
      <nav className="bg-[#2074D9] h-20">
        <div className="flex items-center justify-between p-4 pr-[10%] relative">
          <div>
            <img
              src="./assets/icons/randstad-logo.png"
              alt="Kraft Heinz Logo"
              className="h-26"
            />
          </div>

          <div
            className="burguer-menu cursor-pointer mb-1"
            onClick={toggleMenu}
          >
            <img
              src="./assets/icons/Menu.svg"
              alt="menu"
              className="rounded-none"
            />
          </div>

          <ul
            id="content-burger-menu"
            className={`${"flex flex-row justify-end items-center gap-16 list-meu w-1/2"} ${
              showMenu ? "show" : ""
            }`}
          >
            <li>
              <a href="#sobre" className="text-white">
                sobre nós
              </a>
            </li>
            <li>
              <a href="#oportunidades" className="text-white">
                oportunidades
              </a>
            </li>
            <li>
              <a
                href="https://www.randstad.com.br/contate-nos/contato-candidato/"
                target="_blank"
                className="text-white"
                rel="noreferrer"
              >
                contato
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full bg-[#2074D9] flex justify-center items-center">
        <div className="w-1/2">
          <img
            src="./assets/images/vagas_kraftheinz.Group55_5_.png"
            alt="Kraft Heinz"
            className="w-full"
          />
        </div>
        <div id="main-title" className="flex flex-col items-start z-10 w-1/2">
          <p className="text-white text-8xl font-regular ml-[-8%] max-[768px]:text-xl">
            trabalhe
          </p>
          <p className="text-white text-8xl font-regular ml-[12%] max-[768px]:text-xl">
            conosco
          </p>
          <p className="text-white text-4xl font-regular ml-[40%] max-[768px]:text-sm max-[768px]:ml-[30%]">
            na
          </p>
          <p className="text-white text-8xl font-regular ml-[2%] max-[768px]:text-xl">
            Kraft Heinz
          </p>
        </div>
      </div>

      <div className="flex flex-wrap w-full bg-white py-14 px-[7vw]">
        <h1 className="text-3xl text-blue-500 font-regular mb-6">
          parceria entre Kraft Heinz e Randstad
        </h1>
        <div
          id="parceria"
          className="w-full flex flex-row gap-6 max-[768px]:flex-col"
        >
          <div className="flex items-center w-1/2 gap-[15%] max-[768px]:w-full">
            <img
              src="./assets/images/KraftHeinz2.png"
              alt="Logo Kraft Heinz"
              className="w-[45%]"
            />
            <img
              src="./assets/images/logo-randstad.svg"
              alt="Logo Randstad"
              className="w-[20%]"
            />
          </div>
          <div className="w-1/2 flex max-[768px]:w-full">
            <p className="text-black text-lg">
              A Kraft Heinz, em parceria com a Randstad, líder global em
              recrutamento e soluções completas de recursos humanos, está com
              vagas abertas para a Safra do Tomate de 2024, em Nerópolis- GO.
              Venha fazer parte de uma das maiores empresas de alimentos do
              mundo, referência na produção de alimentos deliciosos e de alta
              qualidade.
            </p>
          </div>
        </div>
      </div>

      <div
        className="flex w-full gap-6 py-14 px-[7vw] max-[768px]:flex-col !pt-0"
        id="sobre"
      >
        <div className="flex flex-col w-1/2 max-[768px]:w-full">
          <h1 className="text-3xl font-regular text-blue-500 mb-4">
            sobre a Kraft Heinz
          </h1>
          <p className="text-lg text-black mb-6">
            Sua razão de existir é o propósito “Vamos tornar a vida deliciosa”,
            que guia o dia a dia de mais de 3.000 colaboradores no país e cria
            momentos memoráveis para pessoas em todo o mundo.
          </p>
          <p className="text-lg text-black mb-6">
            A Kraft Heinz é uma das maiores empresas de alimentos e bebidas do
            mundo, com um portfólio global de mais de 200 marcas icônicas e
            operação em mais de 40 países. No Brasil, é representada pelas
            marcas Heinz, Hemmer, Quero e BR Spices.
          </p>
          <a href="#oportunidades" className="w-[350px]">
            <button className="bg-[#2074D9] text-white w-full h-[60px] rounded-sm hover:bg-blue-600 max-[768px]:w-full">
              Clique aqui e confira nossas vagas
            </button>
          </a>
        </div>

        <div className="w-1/2 h-auto max-[768px]:w-full">
          <img
            src="./assets/images/Maskgroup_5_.png"
            alt="Kraft Heinz"
            className="w-full"
          />
        </div>
      </div>

      <div id="proposito" className="w-full flex flex-row gap-6 px-[7vw]">
        <div className="w-[40%] max-[768px]:w-full">
          <img
            src="./assets/images/vagas_kraftheinz.Maskgroup_3_.png"
            alt="Kraft Heinz"
            className="w-full h-[90%]"
          />
        </div>

        <div className="w-[60%] flex flex-col max-[768px]:w-full">
          <h1 className="text-3xl font-regular text-blue-500 mb-4">
            nosso propósito
          </h1>
          <div className="space-y-2 mb-6">
            <p className="text-lg text-black">
              Nós somos obcecados pelo consumidor
            </p>
            <p className="text-lg text-black">
              Nós ousamos fazer o melhor todos os dias
            </p>
            <p className="text-lg text-black">
              Nós motivamos a excelência em todo nosso time
            </p>
            <p className="text-lg text-black">Nós exigimos a diversidade</p>
            <p className="text-lg text-black">Nós fazemos a coisa certa</p>
            <p className="text-lg text-black">Nós agimos como donos</p>
          </div>
          <p className="text-lg text-black mb-6">
            Caminhamos em direção ao nosso propósito vivendo os nossos valores.
            Essas são as seis principais crenças que dão vida ao nosso
            propósito. Eles constituem nossa linguagem comum definem nossa
            cultura compartilhada e refletem a empresa que queremos nos tornar a
            cada dia.
          </p>
        </div>
      </div>

      <div className="w-full flex flex-col justify-center px-[7vw] max-[768px]:mt-14">
        <h1 className="text-3xl font-regular text-blue-500 mb-4">
          toda história tem um bom começo!
        </h1>
        <p className="text-lg text-black mb-5">
          Foi assim que a Randstad surgiu: de uma grande ideia, através de uma
          bicicleta.
        </p>
        <p className="text-lg text-black mb-5">
          Foi de bike que nosso fundador, lá na Holanda em 1960, levou a
          primeira candidata à sua entrevista de emprego. Hoje, a Randstad é
          líder global em recrutamento e soluções completas de recursos humanos.
        </p>
        <p className="text-lg text-black">
          A companhia combina o poder da tecnologia com o toque humano,
          oferecendo as melhores soluções para empresas e ajudando talentos a se
          manterem relevantes no mundo de trabalho em constante mudança. Está
          presente em mais de 39 países e empregando mais de 670 mil pessoas por
          dia, chegou ao Brasil em 2011, atendendo todas as regiões do país e
          conta com mais de 700 colaboradores.
        </p>
      </div>
      <div
        className="w-full flex flex-col justify-center py-14 px-[7vw]"
        id="oportunidades"
      >
        <h1 className="text-3xl font-regular text-blue-500 mb-4">
          quer uma oportunidade? Então faça sua inscrição!
        </h1>
        <div className="flex max-lg:flex-col justify-between max-lg:gap-4 w-full">
          <select
            onChange={onChangeFilterJobsCity}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas as cidades</option>
            {jobPositionCity.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
              </option>
            ))}
          </select>
          <select
            onChange={onChangeFilterJobsTitle}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas os cargos</option>
            {jobPositionTitle.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name}
              </option>
            ))}
          </select>
        </div>
        {showLoader && (
          <div className="w-[90%] flex flex-col items-center mt-20 max-[768px]:w-full">
            <Spinner animation="grow" variant="primary" />
            <h4 className="text-[#3b82f6] mt-4">Carregando</h4>
          </div>
        )}
        {!showLoader && currentEffectiveJobs.length ? (
          <>
            <ul>
              {currentEffectiveJobs.map((job, i) => (
                <li className="jobs-list" key={i}>
                  <div className="w-[70%] pl-3 max-[768px]:w-full max-[768px]:p-0">
                    <p className="!m-0 max-[768px]:text-center">{job.name}</p>
                  </div>
                  <div className="w-[30%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                    <Button
                      className="py-3 px-5 cursor-pointer self-end"
                      variant="primary"
                      href={job.shortUrl}
                      target="_blank"
                    >
                      candidatar-se
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
            <ReactPaginate
              containerClassName="pagination"
              breakLabel="..."
              nextLabel="Próximo >"
              onPageChange={handlePageClickEffectiveJobs}
              marginPagesDisplayed={2}
              pageCount={pageCountEffectiveJobs}
              forcePage={currentPage}
              previousLabel="< Anterior"
              renderOnZeroPageCount={null}
            />
          </>
        ) : null}
        {!showLoader && !currentEffectiveJobs.length ? (
          <div className="jobs-list !justify-center">
            <h2 className="text-xl">
              Não encontramos resultados para sua busca.
            </h2>
          </div>
        ) : null}
      </div>

      <div className="bg-[#f7f5f0] px-[7vw] py-12">
        <p className="text-black text-2xl mb-8">
          Buscando dicas para a sua carreira? Confira nosso blog
        </p>
        <a
          href="https://www.randstad.com.br/guia-carreira/"
          target="_blank"
          className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition"
          rel="noreferrer"
        >
          acesse nosso blog
        </a>
      </div>

      <footer className="bg-[#2074D9] text-white py-8">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="mb-2">
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p>
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
